// extracted by mini-css-extract-plugin
export default {"title":"d3055880ce","inner_title":"ce765e5c57","charge_btn":"_0f43f47e6b"};